import React from 'react';
import { Link } from 'react-router-dom';
import antiguaImage from '../Images/Countries/anu.png';
import grenadaImage from '../Images/Countries/grenada.png';
import stLuciaImage from '../Images/Countries/st lucia.png';
import stThomasImage from '../Images/Countries/st thomas.png';
import trinidadImage from '../Images/Countries/tt.png';
import stMaartenImage from '../Images/Countries/St Maarten.png';
import './DestinationGrid.css';

const destinations = [
  { name: 'Antigua & Barbuda', slug: 'antigua', image: antiguaImage },
  { name: 'Grenada', slug: 'grenada', image: grenadaImage },
  { name: 'St. Lucia', slug: 'stlucia', image: stLuciaImage },
  { name: 'St. Thomas (USVI)', slug: 'stthomas', image: stThomasImage },
  { name: 'Trinidad & Tobago', slug: 'trinidad', image: trinidadImage },
  { name: 'St. Maarten', slug: 'stmaarten', image: stMaartenImage },
];

export default function DestinationGrid() {
  return (
    <section className="destination-grid" aria-label="Caribbean destinations">
      {destinations.map((destination) => (
        <Link
          className="destination-grid-card"
          key={destination.slug}
          to={`/destinations/${destination.slug}`}
          aria-label={`Explore ${destination.name}`}
        >
          <img src={destination.image} alt={destination.name} />
          <div className="destination-grid-shade" />
          <h3>{destination.name}</h3>
          <span>Explore destination</span>
        </Link>
      ))}
    </section>
  );
}
